import { useState } from "react";
import "./ServicesAccordions.css";

function ServicesAccordions({ items }) {
  const [openIndex, setOpenIndex] = useState(null);

  const handleToggle = (index) => {
    setOpenIndex((prev) => (prev === index ? null : index));
  };

  const hasPartnerFootnote = items.some((item) =>
    (item.title || "").includes("*")
  );

  return (
    <section className="services-accordions-container">
      <div className="services-accordions-inner hover-lift">
        <div className="services-accordions-layout">
          <div className="services-accordions-list">
            {items.map((item, index) => {
              const isOpen = openIndex === index;

              return (
                <article
                  key={item.title + index}
                  className={
                    "services-accordion-item hover-lift" +
                    (isOpen ? " services-accordion-item--open" : "")
                  }
                >
                  <button
                    type="button"
                    className="services-accordion-trigger"
                    onClick={() => handleToggle(index)}
                  >
                    <div className="services-accordion-heading">
                      {item.category && (
                        <span className="services-accordion-category">
                          {item.category}
                        </span>
                      )}
                      <h3>{item.title}</h3>
                    </div>

                    <span
                      className={
                        "services-accordion-icon" + (isOpen ? " is-open" : "")
                      }
                      aria-hidden="true"
                    />
                  </button>

                  <div
                    className={
                      "services-accordion-content-wrapper" +
                      (isOpen ? " is-open" : "")
                    }
                  >
                    <div className="services-accordion-content">
                      <p>{item.text}</p>
                    </div>
                  </div>
                </article>
              );
            })}
          </div>

          <div className="services-accordions-visual">
            <div className="services-accordions-image services-accordions-image--top" />
            <div className="services-accordions-image services-accordions-image--bottom" />
          </div>
        </div>

        {hasPartnerFootnote && (
          <p className="services-accordions-footnote">
            * Leistungen mit Sternchen werden in Zusammenarbeit mit
            spezialisierten Partnerbetrieben erbracht.
          </p>
        )}
      </div>
    </section>
  );
}

export default ServicesAccordions;
